
<template>
<div class="overflow-auto">
  <!-- Le panel affichant la recherche et les résultats europeana -->
  <slideout-panel></slideout-panel>
  <div class="row">
  <b-form-fieldset horizontal class="col-sm-4">
    <b-form-input v-model="filter" placeholder="Rechercher une carte"></b-form-input>
  </b-form-fieldset>
  <b-form-checkbox-group id="checkboxes" class="col-sm-4" v-model="selectedField" :options="options" value-field="value" 
  text-field="text" disabled-field="notEnabled"></b-form-checkbox-group>
  </div>

    <!-- Pagination -->
  <div class="row">
  <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
    <b-col sm="4" md="4" class="my-1">
    <b-form-group label="Cartes par page" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="perPageSelect">
      <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
    </b-form-group>
  </b-col>
  <b-button class="col-sm-2" id="exportButton" variant="outline-dark" @click="exportResult()">Exporter la table</b-button>
  </div>

  <b-table :filter-included-fields="selectedField" :filter-ignored-fields="ignoredFields" ref="table" id="mapListTable" striped hover :current-page="currentPage" 
  :per-page="perPage" :fields="fields" :items="mapListForTable" :filter="filter">
  <template v-slot:cell(actions)="data">    
    <div id="mapTableResultButtons">
      <b-button  v-b-tooltip title="Afficher dans le visualiseur" variant="transparent" @click="showMap(data.item.imageLink)">
        <eyeIcon></eyeIcon>
      </b-button>
      <b-link v-b-tooltip title="Télécharger image TIFF" :href="data.item.mapTiffFormat" style="color: black"><downloadIcon></downloadIcon></b-link>
      &nbsp; 
      <b-button v-b-tooltip title="Rechercher/Ajouter des liens sur Europeana" variant="transparent" @click="showEuropeanaPanel(data.item, true)">
        <!--<searchIcon></searchIcon> -->
        <img src="../../assets/logos/searchLink_36x36.png"  
            alt="logo Europeana"  class="img-fluid" />
      </b-button>
    </div>
  </template>
  <template v-slot:cell(externalLinks)="data">
    <div id="mapTableResultButtons1">
        <b-button v-b-tooltip title="Afficher les données Europeana associées" variant="transparent" @click="showEuropeanaPanel(data.item, false)">
          <img src="../../assets/logos/EuropeanaLogo.png"  
            alt="logo Europeana"  class="img-fluid" />
        </b-button>
        <a v-for="(ark, word) in data.item.bnfLinks" :key='ark' :href="ark" target="blank" v-b-tooltip :title="word">
          <img src="../../assets/logos/BNFLogo.png" alt="logo BNF"  class="img-fluid  logoExternalLink" />
        </a>
    </div>
  </template>
  </b-table>
  
  <div class="row">
  <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
  <!-- Pagination -->
  <b-col sm="4" md="4" class="my-1">
    <b-form-group label="Cartes par page" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="perPageSelect">
      <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
    </b-form-group>
  </b-col>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import EuropeanaSearch from './EuropeanaSearch'
import EuropeanaResourcesForMap from '@components/commons/EuropeanaResourcesForMap'
import SearchIcon from '@components/icons/SearchIcon'
import LayoutIcon from '@components/icons/LayoutIcon'
import DownloadIcon from '@components/icons/DownloadIcon'
import EyeIcon from '@components/icons/EyeIcon'

export default {
  name: 'map-search',
  props: ['mapListForTable'],
  computed: {
    ...mapGetters({
      allMaps: 'getMapListForTable'
    })
  },
  components: { EuropeanaSearch, EuropeanaResourcesForMap, SearchIcon, LayoutIcon, DownloadIcon, EyeIcon },
  data() {
    return {
      // Table options //
      filter: null,
      currentPage: 1,
      perPage: 100,
      pageOptions: [50, 100, 200, 1000, 2000],
      totalRows: null,
      ignoredFields: ['actions'],
      selectedField: ['mapTitle'],
      fields: [
        { key: 'mapIdentifier', label: 'N°Carte' },
        { key: 'mapTitle', label: 'Intitulé' },
        { key: 'contextualizedTitle', label: 'Intitulé contextualisé' },
        { key: 'actions', label: 'Actions' },
        { key: 'externalLinks', label: 'Liens Externes' }
      ],
      // Checkboxes
      options: [
        { text: 'Intitulé', value: 'mapTitle' },
        { text: 'Intitulé contextualisé', value: 'contextualizedTitle' },
        { text: 'N° Carte', value: 'mapIdentifier' }
      ],
    }
  },
  created() {
    this.totalRows = this.mapListForTable.length
  },
  methods: {
    // Met à jour l'index pour visualiser la carte correspondante dans le visualiseur
    // Routage vers la page du visualiseur
    showMap: function(value) {
      this.$store.dispatch('updateIndex', this.allMaps.map(map => { return map.imageLink }).indexOf(value))
      this.$router.push('visualiseur')
    },
    exportResult: function() {
      this.$store.dispatch('exportMapSearchResult', { bootstrapTable: this.$refs.table.filteredItems })
    },
    // Affiche le panel permettant de réaliser des requêtes sur Europeana et d'afficher les résultats
    showEuropeanaPanel: function(map, search) {
      this.$showPanel({
        component: search ? EuropeanaSearch: EuropeanaResourcesForMap,
        openOn: 'right',
        hideBg: false,
        width: '900px',
        props: { currentMap: map }
      })
    }
  }
}
</script>
<style>
#exportButton {
  margin-bottom: 15px;
  margin-left: 25px;
  width: 200px;
}

#checkboxes {
  margin-top: 5px;
}

#mapTableResultButtons {
  text-align: start;
  margin-left: 30%;
}

.logoExternalLink {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/search/MapTableResult.vue